import {
  Inner,
  Section,
  Title,
} from './getToKnow.styles';
import { IGetToKnow } from './interfaces';
import { useGetToKnowHooks } from './getToKnow.hooks';
import { Stage } from './Stage/Stage';
import CarouselFramer from 'components/core/CarouselFramer';

export const GetToKnow = ({ titleAs, title, items }: IGetToKnow) => {
  const { isOpen, onButtonClick, childRef } = useGetToKnowHooks();

  return (
    <Section>
      <Inner>
        <Title as={titleAs}>{title}</Title>
        <CarouselFramer margin={2} childRef={childRef}>
          {items.map((item, index) => {
            return (
              <div ref={childRef} key={index}>
                <Stage {...item} isOpen={isOpen} onClick={onButtonClick} />
              </div>
            );
          })}
        </CarouselFramer>
      </Inner>
    </Section>
  );
};
